import React from 'react';
import { Settings as SettingsIcon } from 'lucide-react';
import { ProfilePicture } from './ProfilePicture.jsx';

export function TopBar({ theme, user, partner, pairStats, onSettingsClick }) {
  return (
    <header style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '14px 20px',
      borderBottom: `1px solid ${theme.border}`,
      background: theme.bg,
      position: 'sticky',
      top: 0,
      zIndex: 50,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <svg width="30" height="30" viewBox="0 0 120 120">
          <g transform="translate(60,60)">
            <rect x="-30" y="-20" width="20" height="40" rx="3" fill={theme.coral}/>
            <rect x="-36" y="-20" width="32" height="9" rx="3" fill={theme.coral}/>
            <rect x="6" y="-22" width="20" height="40" rx="3" fill={theme.gold}/>
            <rect x="0" y="-22" width="32" height="9" rx="3" fill={theme.gold}/>
          </g>
        </svg>
        <div>
          <div style={{ fontSize: 15, fontWeight: 700, lineHeight: 1.1 }}>Tag Team</div>
          <div style={{ fontSize: 10, color: theme.textMuted }}>
            {pairStats?.loveScore ? `${pairStats.loveScore} kærlighedspoint` : 'Get sh*it done · mindre stress · mere kærlighed'}
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <ProfilePicture user={user} size={28} theme={theme} />
        <button onClick={onSettingsClick} style={{
          background: 'transparent', border: 'none',
          color: theme.textMuted, cursor: 'pointer',
          padding: 6, borderRadius: 6,
          display: 'flex', alignItems: 'center',
        }} title="Indstillinger">
          <SettingsIcon size={18} />
        </button>
      </div>
    </header>
  );
}
